// Shared style fragments used across multiple recipes.

// Standard transition for interactive components — controls (buttons,
// inputs, triggers, tabs) and surfaces with hover state (cards, tags).
// Matches Button's transition so every interactive element animates on
// the same timing curve.
export const interactiveTransition = {
  transitionProperty:
    "background-color, border-color, color, box-shadow, transform",
  transitionDuration: "fast",
  transitionTimingFunction: "out",
};
